import React, { useEffect, useState } from 'react';
import { Accordion, Button, Col, Container, Form, Row, Table } from 'react-bootstrap';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';

import StepHeader from "../../../components/v2/StepHeader"
import DepartmentHeader from "../../../components/v2/DepartmentHeader";
import AssessmentPlanningDialog from '../../../components/v2/AssessmentPlanningDialog';

import FORM_QUESTIONS_TAB1 from '../../../step5_tab1_questions.json';
import FORM_QUESTIONS_TAB2 from '../../../step5_tab2_questions.json';

import { SECOND_ROUND_DROPDOWN_ACTIVE } from '../../../fastConstants.js';

function EditButton(props) {
    return (
        <>
        {props.completed
            ?
            <Button
                onClick={props.onClick}
                variant="success"
                className="w-100"
                size="md"
                id={'program-' + props.programId + '_slo-' + props.sloId}
                disabled={props.disabled}
                >
                <span className="px-2" id="edit">Edit</span>
                <FontAwesomeIcon icon={faCheck} inverse 
                    id="icon"
                    onClick={props.onClick}
                    />
            </Button>
            :
            <Button
                onClick={props.onClick}
                variant="success"
                className="w-100"
                size="md"
                id={'program-' + props.programId + '_slo-' + props.sloId}
                disabled={props.disabled}
                >
                <span className="px-2" id="edit">Edit</span>
            </Button>
        }
        </>
    )
}

function CompletedCheckBox(props) {
    return (
        <Form.Check
            type="checkbox"
            onChange={props.onChange}
            id={'program-' + props.programId + '_step-' + props.step}
            name={'program-' + props.programId + '_step-' + props.step}
            aria-label={props.ariaLabel}
            label={props.label}
            value={props.completed}
            defaultChecked={props.defaultChecked}
            disabled={props.disabled}
            />
    )
}

const EMPTY_PLAN_CHANGES = {
    "s5q1": "",
    "s5q2": "",
    "s5q3": "",
    "s5q4": "",
    "s5q5": "",
    "s5q14": "",
}
const EMPTY_PLAN_ASSESSMENT = {
    "s5q17": "",
    "s5q18": "",
    "s5q19": "",
    "s5q20": "",
}

const EMPTY_STEP_DATA = {
    "planChanges": EMPTY_PLAN_CHANGES,
    "planAssessment": EMPTY_PLAN_ASSESSMENT,
}

export default function AssessmentStep5(props) {
    const [programId, setProgramId] = useState(0);

    // Used for Assessment Planning Dialog
    const [selectedProgram, setSelectedProgram] = useState()
    const [selectedLearningOutcome, setSelectedLearningOutcome] = useState()
    const [stepData, setStepData] = useState(EMPTY_STEP_DATA)
    const [stepDataStore, setStepDataStore] = useState({})

    const [stepTab1Data, setTab1Data] = useState(EMPTY_PLAN_CHANGES)
    const [stepTab1DataStore, setTab1DataStore] = useState({})

    const [stepTab2Data, setTab2Data] = useState(EMPTY_PLAN_ASSESSMENT)
    const [stepTab2DataStore, setTab2DataStore] = useState({})

    const [defaultTab, setDefaultTab] = useState('tab-1')
    const [showModal, setShowModal] = useState(false);

    let prefix = "program-";
    let tab1Key = "planChanges"
    let tab2Key = "planAssessment"

    useEffect(() => {
        if (selectedLearningOutcome && (selectedLearningOutcome.sloId in stepTab1DataStore)) {
            if (Object.keys(stepTab1Data).length == 0) {
                setTab1Data({...stepTab1DataStore[selectedLearningOutcome.sloId]})
            }
        } else {
            setTab1Data({...EMPTY_PLAN_CHANGES})
        }
    }, [stepTab1DataStore])

    useEffect(() => {
        if (selectedLearningOutcome && (selectedLearningOutcome.sloId in stepTab2DataStore)) {
            setTab2Data({...stepTab2DataStore[selectedLearningOutcome.sloId]})
        } else {
            setTab2Data({...EMPTY_PLAN_ASSESSMENT})
        }
    }, [stepTab2DataStore])

    useEffect(() => {
        if (selectedProgram && (selectedProgram.programId in props.step5Tab1DataStore)) {
            setTab1DataStore({...props.step5Tab1DataStore[selectedProgram.programId]})
        } else {
            setTab1DataStore({})
            setTab1Data({...EMPTY_PLAN_CHANGES})
        }
    
        if (selectedProgram && (selectedProgram.programId in props.step5Tab2DataStore)) {
            setTab2DataStore({...props.step5Tab2DataStore[selectedProgram.programId]})
        } else {
            setTab2DataStore({})
            setTab2Data({...EMPTY_PLAN_ASSESSMENT})
        }
    }, [selectedProgram])

    const handleOpenDialogTab1 = (event) => {
        let id = event.target.id
        let tokens = event.target.id.split('_')
        if (id === 'edit' || id === 'icon') {
            tokens = event.target.parentElement.id.split('_')
        }
        let programId = tokens[0].split('-')[1]
        let sloId = tokens[1].split('-')[1]
        let program = props.department.submittedPrograms.find(p => p.programId == programId)
        
        setProgramId(programId)
        setSelectedProgram(program)

        // Update which learning outcome the edit dialog was opened for.
        let slo = props.learningOutcomes[programId].find(lo => lo.sloId == sloId)
        setSelectedLearningOutcome({...slo})
        setTab1Data({...stepTab1DataStore[sloId]})
        setTab2Data({...stepTab2DataStore[sloId]})

        setShowModal(true)
        setDefaultTab('tab-1')
    }
    const handleOpenDialogTab2 = (event) => {
        let id = event.target.id
        let tokens = event.target.id.split('_')
        if (id === 'edit' || id === 'icon') {
            tokens = event.target.parentElement.id.split('_')
        }
        let programId = tokens[0].split('-')[1]
        let sloId = tokens[1].split('-')[1]
        let program = props.department.submittedPrograms.find(p => p.programId == programId)
        
        setProgramId(programId)
        setSelectedProgram(program)

        // Update which learning outcome the edit dialog was opened for.
        let slo = props.learningOutcomes[programId].find(lo => lo.sloId == sloId)
        setSelectedLearningOutcome({...slo})
        setTab1Data({...stepTab1DataStore[sloId]})
        setTab2Data({...stepTab2DataStore[sloId]})

        setShowModal(true)
        setDefaultTab('tab-2')
    }

    const handleLearningOutcomeChanged = (event) => {
        let tmpLearningOutcome = selectedLearningOutcome ? selectedLearningOutcome : props.selectedLearningOutcome
        let previousSloId = tmpLearningOutcome.sloId
        let nextSloId = event.target.value
        let tmpSelectedProgram = selectedProgram ? selectedProgram : props.selectedProgram

        let slo = props.learningOutcomes[tmpSelectedProgram.programId].find(lo => lo.sloId == nextSloId)
        setSelectedLearningOutcome(slo)

        // Save the previous step data
        if (defaultTab === 'tab-1') {
            let dirtyDataStore = {...stepTab1DataStore}
            dirtyDataStore[previousSloId] = {...stepTab1Data}
            setTab1DataStore({...dirtyDataStore})
        } else if (defaultTab === 'tab-2') {
            let dirtyDataStore = {...stepTab2DataStore}
            dirtyDataStore[previousSloId] = {...stepTab2Data}
            setTab2DataStore({...dirtyDataStore})
        }

        // Show the next step data
        if (nextSloId in stepDataStore) {
            if (defaultTab === 'tab-1') {
                setTab1Data({...stepTab1DataStore[nextSloId]})
            } else if (defaultTab === 'tab-2') {
                setTab2Data({...stepTab2DataStore[nextSloId]})
            }
        } else {
            setStepData({...EMPTY_STEP_DATA})
        }
    }

    const handleCancelDialog = () => {
        setProgramId()
        setSelectedProgram()
        setShowModal(false)
    }

    const handleCloseDialog = () => {
        let sloId = selectedLearningOutcome.sloId
        let data = {
            department: props.department,
            program: selectedProgram,
        }
        // Save the previous step data

        let dirtyDataStore1 = {...stepTab1DataStore}
        dirtyDataStore1[sloId] = {...stepTab1Data}
        setTab1DataStore({...dirtyDataStore1})
        data['stepTab1DataStore'] = dirtyDataStore1
        
        let dirtyDataStore2 = {...stepTab2DataStore}
        dirtyDataStore2[sloId] = {...stepTab2Data}
        setTab2DataStore({...dirtyDataStore2})

        data['stepTab2DataStore'] = dirtyDataStore2
        
        props.handleStep5DialogSave(data)

        setShowModal(false)
    }

    const isTab1EditAllowed = (programId, sloId) => {
        if (!props.step4CompletionData[programId] ||
            !props.step4CompletionData[programId].completed) {
            return false
        }
        
        return true
    }

    const isTab2EditAllowed = (programId, sloId) => {
        if (props.step5Tab1DataStore && (programId in props.step5Tab1DataStore)) {
            let tab1Data = props.step5Tab1DataStore[programId]
            if (sloId in tab1Data) {
                return false
            }
        }
        return true
    }

    const isFieldEmpty = (field, isRequired) => {
        if (isRequired) {
            // does field NOT have a value?
            // or
            // does the field have a value, but the value is an empty string?
            return !field || field && field.trim().length == 0;
        }
        return false
    }

    const isSkipSecondCollection = (field, isRequired) => {
        // TODO: remove when we get feedback from ODS on whether we keep this feature
        if (SECOND_ROUND_DROPDOWN_ACTIVE) {
            return false
        }

        // we need to determine if the dropdown is "yes"
        // any other value is "no".
        if (field && field === "yes") {
            return false
        }
        return true
    }

    const missingChangeTypes = (programId, sloId, isRequired) => {
        if (!isRequired) {
            return false
        }
        let step5Tab1Data = props.step5Tab1DataStore[programId][sloId]

        let isCheckedS5Q6 = step5Tab1Data.s5q6
        if (isCheckedS5Q6) {
            return false
        }
        let isCheckedS5Q7 = step5Tab1Data.s5q7
        if (isCheckedS5Q7) {
            return false
        }
        let isCheckedS5Q8 = step5Tab1Data.s5q8
        if (isCheckedS5Q8) {
            return false
        }
        let isCheckedS5Q9 = step5Tab1Data.s5q9
        if (isCheckedS5Q9) {
            return false
        }
        let isCheckedS5Q10 = step5Tab1Data.s5q10
        if (isCheckedS5Q10) {
            return false
        }
        let isCheckedS5Q11 = step5Tab1Data.s5q11
        if (isCheckedS5Q11) {
            return false
        }
        let isCheckedS5Q12 = step5Tab1Data.s5q12
        if (isCheckedS5Q12) {
            return false
        }
        let isCheckedS5Q13 = step5Tab1Data.s5q13
        if (isCheckedS5Q13) {
            return false
        }

        // If we are here, no check boxes were checked.
        return true
    }

    const isSloTab1Complete = (programId, sloId) => {
        let result = true
        if (programId in props.step5Tab1DataStore &&
            sloId in props.step5Tab1DataStore[programId]) {

            // s5q30
            let selectionS5Q30 = props.step5Tab1DataStore[programId][sloId].s5q30
            let cycleSecondDataCollectionRequired = FORM_QUESTIONS_TAB1["cycleSecondDataCollection"].required
            if (SECOND_ROUND_DROPDOWN_ACTIVE === false) {
                selectionS5Q30 = "yes"
            }

            if (!isSkipSecondCollection(selectionS5Q30, cycleSecondDataCollectionRequired)) {
                // s5q1
                let textS5Q1 = props.step5Tab1DataStore[programId][sloId].s5q1
                let changesPlannedRequired = FORM_QUESTIONS_TAB1["changesPlanned"].required

                // s5q2
                let textS5Q2 = props.step5Tab1DataStore[programId][sloId].s5q2
                let dataMotivatedChangesRequired = FORM_QUESTIONS_TAB1["dataMotivatedChanges"].required

                // s5q3
                let textS5Q3 = props.step5Tab1DataStore[programId][sloId].s5q3
                let hypothesisAboutChangesRequired = FORM_QUESTIONS_TAB1["hypothesisAboutChanges"].required

                // s5q4
                let textS5Q4 = props.step5Tab1DataStore[programId][sloId].s5q4
                let changeInApproachRequired = FORM_QUESTIONS_TAB1["changeInApproach"].required

                // s5q5
                let textS5Q5 = props.step5Tab1DataStore[programId][sloId].s5q5
                let staffInvolvedRequired = FORM_QUESTIONS_TAB1["facultyInvolved"].required
                
                // s5q6 thru s5q13 - Need at least one checked
                let typeOfChangesRequired = FORM_QUESTIONS_TAB1["typeOfChanges"].required

                // If a field on Tab 1 are undefined - step NOT complete
                // If a field is empty/blank - step NOT complete
                if (isFieldEmpty(textS5Q1, changesPlannedRequired)) {
                    result = false
                }
                if (isFieldEmpty(textS5Q2, dataMotivatedChangesRequired)) {
                    result = false
                }
                if (isFieldEmpty(textS5Q3, hypothesisAboutChangesRequired)) {
                    result = false
                }
                if (isFieldEmpty(textS5Q4, changeInApproachRequired)) {
                    result = false
                }
                if (isFieldEmpty(textS5Q5, staffInvolvedRequired)) {
                    result = false
                }
                if (missingChangeTypes(programId, sloId, typeOfChangesRequired)) {
                    result = false
                }
            }

        } else {
            result = false
        }
        return result
    }

    const isSloTab2Complete = (programId, sloId) => {
        let result = true
        if (programId in props.step5Tab2DataStore &&
            sloId in props.step5Tab2DataStore[programId]) {

            // s5q30
            let selectionS5Q30 = props.step5Tab1DataStore[programId][sloId].s5q30
            let cycleSecondDataCollectionRequired = FORM_QUESTIONS_TAB1["cycleSecondDataCollection"].required
            if (SECOND_ROUND_DROPDOWN_ACTIVE === false) {
                    selectionS5Q30 = "yes"
                }

            if (!isSkipSecondCollection(selectionS5Q30, cycleSecondDataCollectionRequired)) {
                // s5q17
                let textS5Q17 = props.step5Tab2DataStore[programId][sloId].s5q17
                let toolDesriptionRequired = FORM_QUESTIONS_TAB2["secondRoundToolDescription"].required
                // s5q18
                let textS5Q18 = props.step5Tab2DataStore[programId][sloId].s5q18
                let coursesAssessedRequired = FORM_QUESTIONS_TAB2["secondRoundCoursesAssessed"].required
                // s5q19
                let textS5Q19 = props.step5Tab2DataStore[programId][sloId].s5q19
                let brightspaceUsageRequired = FORM_QUESTIONS_TAB2["brightspaceAutomation"].required
                // s5q20
                let textS5Q20 = props.step5Tab2DataStore[programId][sloId].s5q20
                let secondRoundDataRequired = FORM_QUESTIONS_TAB2["secondRoundDataCollection"].required
                
                if (toolDesriptionRequired &&
                    (!textS5Q17 || textS5Q17 && textS5Q17.trim().length == 0)) {
                    result = false
                }

                if (coursesAssessedRequired && 
                    (!textS5Q18 || textS5Q18 && textS5Q18.trim().length == 0)) {
                    result = false
                }

                if (brightspaceUsageRequired &&
                    (!textS5Q19 || textS5Q19 && textS5Q19.trim().length == 0)) {
                    result = false
                }

                if (secondRoundDataRequired &&
                    (!textS5Q20 || textS5Q20 && textS5Q20.trim().length == 0)) {
                    result = false
                }
            }

        } else {
            result = false
        }
        return result
    }

    ///////////////////////////////////////////////////////////////////////
    //
    // 
    //
    ///////////////////////////////////////////////////////////////////////
    const noSecondRoundCollection = (programId) => {
        let totalLearningOutcomes = availableLearningOutcomes[programId]?.length
        let count = 0
        // Track how many learning outcomes and how many are "No" for s5q30
        availableLearningOutcomes[programId]?.map((slo) => {
            if (programId in props.step5Tab1DataStore && slo.sloId in props.step5Tab1DataStore[programId]) {
                // s5q30
                let selectionS5Q30 = props.step5Tab1DataStore[programId][slo.sloId].s5q30
                if (selectionS5Q30 == undefined || selectionS5Q30.startsWith("no")) {

                    // TODO: Let's pivot to disabling the completed check box when there is no "yes" answer
                    //       to any of the s5q30 questions.
                    count += 1
                }
            }
        })
        return count == totalLearningOutcomes
    }
    ///////////////////////////////////////////////////////////////////////
    //
    // Handle the clearing of Tab 1 data
    //
    ///////////////////////////////////////////////////////////////////////
    const clearStep1Data = () => {
        setTab1Data(
            prevStepTab1Data => ({...prevStepTab1Data,
                s5q1: '',
                s5q2: '',
                s5q3: '',
                s5q4: '',
                s5q5: '',
                s5q6: false,
                s5q7: false,
                s5q8: false,
                s5q9: false,
                s5q10: false,
                s5q11: false,
                s5q12: false,
                s5q13: false,
                s5q14: '',
                s5q15: ''
            })
        )
    }
    ///////////////////////////////////////////////////////////////////////
    //
    // Handle the change of Tab 1 Question 30 (TODO: remove after end user verifies dropdown)
    //
    ///////////////////////////////////////////////////////////////////////
    const onStep5Question30Changed = (event) => {
        setTab1Data(prevStepTab1Data => ({...prevStepTab1Data, s5q30: event.target.value}))

        // If the selection is "no", clear out the rest of the tab 1 data.
        // If the selection is "yes", tab 1 was already cleared, so clearing
        // it again does no harm. 
        clearStep1Data()
    }

    const isStepComplete = (programId) => {
        // Prevent edit of step if next step is complete
        if (props.step6CompletionData[programId] &&
            props.step6CompletionData[programId].completed) {
            return false
        }

        // Step cannot be completed if previous steps were not.
        if (!props.step4CompletionData[programId] ||
            !props.step4CompletionData[programId].completed) {
            return false
        }
        if (!props.step3CompletionData[programId] ||
            !props.step3CompletionData[programId].completed) {
            return false
        }
        if (!props.step2CompletionData[programId] ||
            !props.step2CompletionData[programId].completed) {
            return false
        }
        if (!props.step1CompletionData[programId] ||
            !props.step1CompletionData[programId].completed) {
            return false
        }
        
        let result = true
        // Verify the Program learning outcome answers for both tabs
        availableLearningOutcomes[programId].map((slo) => {
            if (programId in props.step5Tab1DataStore &&
                    slo.sloId in props.step5Tab1DataStore[programId]) {

                // s5q30
                let selectionS5Q30 = props.step5Tab1DataStore[programId][slo.sloId].s5q30
                let cycleSecondDataCollectionRequired = FORM_QUESTIONS_TAB1["cycleSecondDataCollection"].required
                if (SECOND_ROUND_DROPDOWN_ACTIVE === false) {
                    selectionS5Q30 = "yes"
                }

                if (!isSkipSecondCollection(selectionS5Q30, cycleSecondDataCollectionRequired)) {
                    // s5q1 - Changes Planned
                    let textS5Q1 = props.step5Tab1DataStore[programId][slo.sloId].s5q1
                    let changesPlannedRequired = FORM_QUESTIONS_TAB1["changesPlanned"].required
                    // s5q2 - Data motivating the changes
                    let textS5Q2 = props.step5Tab1DataStore[programId][slo.sloId].s5q2
                    let dataMotivatedChangesRequired = FORM_QUESTIONS_TAB1["dataMotivatedChanges"].required
                    // s5q3 - Hypothesis about the changes
                    let textS5Q3 = props.step5Tab1DataStore[programId][slo.sloId].s5q3
                    let hypothesisAboutChangesRequired = FORM_QUESTIONS_TAB1["hypothesisAboutChanges"].required
                    // s5q4 - Will the changes require a change in assessment approach or tools?
                    let textS5Q4 = props.step5Tab1DataStore[programId][slo.sloId].s5q4
                    let changeInApproachRequired = FORM_QUESTIONS_TAB1["changeInApproach"].required
                    // s5q5 - If the changes involve all faculty...
                    let textS5Q5 = props.step5Tab1DataStore[programId][slo.sloId].s5q5
                    let facultyInvolvedRequired = FORM_QUESTIONS_TAB1["facultyInvolved"].required

                    // s5q6 thru s5q13 - Need at least one checked
                    let typeOfChangesRequired = FORM_QUESTIONS_TAB1["typeOfChanges"].required

                    // s5q17 - Description of tool used second round
                    let textS5Q17 = props.step5Tab2DataStore[programId][slo.sloId].s5q17
                    let toolDesriptionRequired = FORM_QUESTIONS_TAB2["secondRoundToolDescription"].required
                    // s5q18 - Course(s) assessed second round
                    let textS5Q18 = props.step5Tab2DataStore[programId][slo.sloId].s5q18
                    let coursesAssessedRequired = FORM_QUESTIONS_TAB2["secondRoundCoursesAssessed"].required
                    // s5q19 - Will Brightspace be used to automate data collection?
                    let textS5Q19 = props.step5Tab2DataStore[programId][slo.sloId].s5q19
                    let brightspaceUsageRequired = FORM_QUESTIONS_TAB2["brightspaceAutomation"].required
                    // s5q20 - When will second round data be collected?
                    let textS5Q20 = props.step5Tab2DataStore[programId][slo.sloId].s5q20
                    let secondRoundDataRequired = FORM_QUESTIONS_TAB2["secondRoundDataCollection"].required

                    

                    // If any of the fields on Tab 1 are undefined - step NOT complete
                    if (isFieldEmpty(textS5Q1, changesPlannedRequired)) {
                        result = false
                    }
                    if (isFieldEmpty(textS5Q2, dataMotivatedChangesRequired)) {
                        result = false
                    }
                    if (isFieldEmpty(textS5Q3, hypothesisAboutChangesRequired)) {
                        result = false
                    }
                    if (isFieldEmpty(textS5Q4, changeInApproachRequired)) {
                        result = false
                    }
                    if (isFieldEmpty(textS5Q5, facultyInvolvedRequired)) {
                        result = false
                    }
                    if (missingChangeTypes(programId, slo.sloId, typeOfChangesRequired)) {
                        result = false
                    }

                    // If any of the fields on Tab 2 are undefined - step NOT complete
                    if (isFieldEmpty(textS5Q17, toolDesriptionRequired)) {
                        result = false
                    }

                    if (isFieldEmpty(textS5Q18, coursesAssessedRequired)) {
                        result = false
                    }

                    if (isFieldEmpty(textS5Q19, brightspaceUsageRequired)) {
                        result = false
                    }

                    if (isFieldEmpty(textS5Q20, secondRoundDataRequired)) {
                        result = false
                    }
                }

            } else {
                if (!(programId in props.step5Tab1DataStore)) {
                    // No answers found for the Program
                    result = false
                } else if (!(slo.sloId in props.step5Tab1DataStore[programId])) {
                    // The learning outcome ID was not found in first Tab.
                    result = false
                }
            }
        })

        if (SECOND_ROUND_DROPDOWN_ACTIVE === true && noSecondRoundCollection(programId)) {
            // all the answers to second round of data collection are "no"
            // this is not allowed
            result = false
        }

        return result
    }

    React.useEffect(() => {
        window.scrollTo(0,0)
    }, [])
    
    let allPrograms = props.department.submittedPrograms
    let filteredPrograms = []

    filteredPrograms = allPrograms.filter(function(obj) {
        return (props.activePrograms[obj.programId] == 'yes')
    })

    let themeName = props.theme.name
    let availableLearningOutcomes = {}
    props.department.submittedPrograms.map(program => {
        let programMappedSlos = props.mappedSlos[program.programId]
        if (!(program.programId in availableLearningOutcomes)) {
            availableLearningOutcomes[program.programId] = []
        }

        if (program.programId in props.learningOutcomes) {
            props.learningOutcomes[program.programId].map(slo => {
                if (slo.sloId in programMappedSlos) {
                    let mappedSlo = programMappedSlos[slo.sloId]
                    if (mappedSlo.firstTheme === themeName && mappedSlo.firstThemeAnswer === 'yes') {
                        availableLearningOutcomes[program.programId].push(slo)
                    } else if (mappedSlo.secondTheme === themeName && mappedSlo.secondThemeAnswer === 'yes') {
                        availableLearningOutcomes[program.programId].push(slo)
                    } else if (mappedSlo.thirdTheme === themeName && mappedSlo.thirdThemeAnswer === 'yes') {
                        availableLearningOutcomes[program.programId].push(slo)
                    }
                }
            })
        }
    })

    // defaultTabs is provided to Accordion to expand all accordion items by default.
    //let defaultTabs = Array.from(props.department.submittedPrograms, (p,k) => 'program-' + k)
    let defaultTabs = []
    props.department.submittedPrograms.forEach((p) => {
        if (!(p.programId in props.step5CompletionData && props.step5CompletionData[p.programId].completed)) {
            defaultTabs.push(prefix + p.programId)
        }
    })
    return (
        <React.Fragment>
            <StepHeader text={props.stepTitle} />

            <div className="p-5 pb-md-4 mx-auto">
                <div className="p-1 text-center">
                    <p>
                        Use the ‘Edit’ buttons below to describe plans for changes that will 
                        be implemented in each program (degree, certificate, and gen ed area) 
                        and how the second round of assessment data collection will be conducted 
                        after the changes are implemented. Each program should establish a change 
                        to curriculum or instruction that targets improvement on at least one 
                        current outcome, and which goes beyond changes to the assessment tools/procedures. 
                    </p>
                        
                    <p>
                        Please review background information about Designing and Planning Changes 
                        before continuing: <a href="https://rise.articulate.com/share/FcrbFC3QbiBCGEVeQfetTjURoEU7v4uR" target="_blank" rel="noopener noreferrer">View</a>
                    </p>
                </div>
                <div className="p-1 text-center">
                    If you have any data attachments or additional information or documents to 
                    share or save please save your documents in <a href="https://livecnm.sharepoint.com/:f:/t/SAAC/ElP7hfcN6OVMhcTxMFhKQSUB-TcaxizLB3gZuRrXPXf0iA?e=nlvD7d" target="_blank" rel="noopener noreferrer">this SAAC folder</a>.
                    Suggested naming convention: <span className="fst-italic">PROGRAM PREFIX_DocType_year</span>
                    <p className="p-2">
                    For example, <span className="fw-bold">THEA_data_2023</span> or <span className="fw-bold">FILM_rubric_2023</span>
                    </p>
                </div>

                <DepartmentHeader department={props.department} />

                <div className="pb-md-4 mx-auto">
                <Accordion defaultActiveKey={defaultTabs} alwaysOpen>
                {
                    filteredPrograms.map((program, key) =>
                    <Accordion.Item eventKey={prefix + program.programId} key={program.programId}>
                        <Accordion.Header>
                            {program.name} {(program.programId in props.step5CompletionData && props.step5CompletionData[program.programId].completed) ? ' - Completed' : ''}
                        </Accordion.Header>
                        <Accordion.Body>
                            <Table key={key}>
                                <thead>
                                    <tr>
                                        <th>Learning Outcome</th>
                                        <th className="mx-auto text-center"></th>
                                        <th className="mx-auto text-center">Plan Changes</th>
                                        <th className="mx-auto text-center">Plan Assessment</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        availableLearningOutcomes[program.programId].map((slo,index) => {
                                            return (
                                            <tr key={index}>
                                                <td>{ slo.text }</td>
                                                <td>
                                                </td>
                                                <td width="10%">
                                                    <EditButton 
                                                        onClick={handleOpenDialogTab1}
                                                        programId={program.programId}
                                                        sloId={slo.sloId}
                                                        disabled={!isTab1EditAllowed(program.programId, slo.sloId)}
                                                        completed={isSloTab1Complete(program.programId, slo.sloId)}
                                                        />
                                                </td>
                                                <td width="10%">
                                                    <EditButton
                                                        onClick={handleOpenDialogTab2}
                                                        programId={program.programId}
                                                        sloId={slo.sloId}
                                                        disabled={isTab2EditAllowed(program.programId, slo.sloId)}
                                                        completed={isSloTab2Complete(program.programId, slo.sloId)}
                                                        />
                                                </td>
                                            </tr>
                                            )
                                        })
                                    }
                                </tbody>
                            </Table>

                            <Container fluid>
                                <Row>
                                    <Col 
                                        md={{span: 8, offset: 3}}
                                        lg={{span: 12, offset: 3}}
                                        >
                                        <CompletedCheckBox
                                            onChange={props.onStepCompleted}
                                            programId={program.programId}
                                            completed={props.step5CompletionData[program.programId]?.completed}
                                            defaultChecked={props.step5CompletionData[program.programId]?.completed}
                                            ariaLabel="Step 5 is complete"
                                            label="By checking this box you are completing Step 5 for your program area"
                                            step="5"
                                            disabled={!isStepComplete(program.programId)}
                                            />
                                    </Col>
                                </Row>
                                { (SECOND_ROUND_DROPDOWN_ACTIVE === true && noSecondRoundCollection(program.programId)) ?
                                    <Row>
                                        <Col className="text-center text-danger mt-3">
                                            Action Required: At least one outcome must be assessed a second time within the two-year assessment cycle. 
                                            Please select an outcome for reassessment before continuing.
                                        </Col>
                                    </Row>
                                    : <></>
                                }
                                
                            </Container>
                        </Accordion.Body>
                    </Accordion.Item>
                    )
                }
                </Accordion>
                <AssessmentPlanningDialog
                    department={props.department}
                    theme={props.theme}
                    selectedProgram={selectedProgram}
                    selectedLearningOutcome={selectedLearningOutcome}
                    learningOutcomes={availableLearningOutcomes}

                    sloQuestions={props.sloQuestions}
                    step1DataStore={props.step1DataStore}
                    sloAnalysis={props.sloAnalysis[selectedProgram?.programId]}
                    stepData={stepData}
                    stepTab1Data={stepTab1Data}
                    stepTab2Data={stepTab2Data}
                    step2DataStore={props.step2DataStore}
                    step4DataStore={props.step4DataStore}
                    step5Tab1DataStore={props.step5Tab1DataStore}
                    step5Tab2DataStore={props.step5Tab2DataStore}
                    step1CompletionData={props.step1CompletionData}
                    step2CompletionData={props.step2CompletionData}
                    step3CompletionData={props.step3CompletionData}
                    step4CompletionData={props.step4CompletionData}
                    stepCompletionData={props.step5CompletionData}

                    

                    showModal={showModal}
                    defaultTab={defaultTab}
                    handleCloseDialog={handleCloseDialog}
                    handleCancelDialog={handleCancelDialog}
                    handleLearningOutcomeChanged={handleLearningOutcomeChanged}
                    handleS5Q30Changed={(e) => setTab1Data(prevStepTab1Data => ({...prevStepTab1Data, s5q30: e.target.value}))}
                    handleS5Q1Changed={(e) => setTab1Data(prevStepTab1Data => ({...prevStepTab1Data, s5q1: e.target.value}))}
                    handleS5Q2Changed={(e) => setTab1Data(prevStepTab1Data => ({...prevStepTab1Data, s5q2: e.target.value}))}
                    handleS5Q3Changed={(e) => setTab1Data(prevStepTab1Data => ({...prevStepTab1Data, s5q3: e.target.value}))}
                    handleS5Q4Changed={(e) => setTab1Data(prevStepTab1Data => ({...prevStepTab1Data, s5q4: e.target.value}))}
                    handleS5Q5Changed={(e) => setTab1Data(prevStepTab1Data => ({...prevStepTab1Data, s5q5: e.target.value}))}
                    handleS5Q6Changed={(e) => setTab1Data(prevStepTab1Data => ({...prevStepTab1Data, s5q6: e.target.checked}))}
                    handleS5Q7Changed={(e) => setTab1Data(prevStepTab1Data => ({...prevStepTab1Data, s5q7: e.target.checked}))}
                    handleS5Q8Changed={(e) => setTab1Data(prevStepTab1Data => ({...prevStepTab1Data, s5q8: e.target.checked}))}
                    handleS5Q9Changed={(e) => setTab1Data(prevStepTab1Data => ({...prevStepTab1Data, s5q9: e.target.checked}))}
                    handleS5Q10Changed={(e) => setTab1Data(prevStepTab1Data => ({...prevStepTab1Data, s5q10: e.target.checked}))}
                    handleS5Q11Changed={(e) => setTab1Data(prevStepTab1Data => ({...prevStepTab1Data, s5q11: e.target.checked}))}
                    handleS5Q12Changed={(e) => setTab1Data(prevStepTab1Data => ({...prevStepTab1Data, s5q12: e.target.checked}))}
                    handleS5Q13Changed={(e) => setTab1Data(prevStepTab1Data => ({...prevStepTab1Data, s5q13: e.target.checked}))}
                    handleS5Q14Changed={(e) => setTab1Data(prevStepTab1Data => ({...prevStepTab1Data, s5q14: e.target.value}))}
                    handleS5Q15Changed={(e) => setTab1Data(prevStepTab1Data => ({...prevStepTab1Data, s5q15: e.target.value}))}

                    handleS5Q16Changed={(e) => setTab2Data(prevStepTab2Data => ({...prevStepTab2Data, s5q16: e.target.value}))}
                    handleS5Q17Changed={(e) => setTab2Data(prevStepTab2Data => ({...prevStepTab2Data, s5q17: e.target.value}))}
                    handleS5Q18Changed={(e) => setTab2Data(prevStepTab2Data => ({...prevStepTab2Data, s5q18: e.target.value}))}
                    handleS5Q19Changed={(e) => setTab2Data(prevStepTab2Data => ({...prevStepTab2Data, s5q19: e.target.value}))}
                    handleS5Q20Changed={(e) => setTab2Data(prevStepTab2Data => ({...prevStepTab2Data, s5q20: e.target.value}))}
                    />
                </div>
            </div>
        </React.Fragment>
    )
}